import { Model } from "./model.model";

export class Gpt4omodel extends Model {
  MAX_NUMBER_OF_CHARACTERS: number = 86000;
  TOKENS: number = 128000;
}
